// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__8FQan","clinicsSelect":"TableHeading_clinicsSelect__1fIbH"};